import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Motion";
import { ComboCard } from "../components/ComboCard";
import { ChooseYourCurry } from "../components/ChooseYourCurry";
import { useOrder } from "../components/OrderProvider";
import PageHeader from "../components/layout/PageHeader";
import MenuTabs from "../components/layout/MenuTabs";
import { combos } from "../data/menu";
import { business } from "../data/site";
import SEO from "../components/SEO";

export default function ComboMeals() {
  const openOrder = useOrder();
  return (
    <div data-testid="combo-meals-page">
      <SEO
        route="menu-combos"
        fallbackTitle="Combo Meals | Shaan Curry House Ottawa"
        fallbackDescription="Great-value Indian combo meals in Ottawa. Butter chicken, tikka masala, biryani and more with rice, naan and sides."
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "Menu", url: "/menu/combos" },
          { name: "Combo Meals", url: "/menu/combos" },
        ]}
      />
      <PageHeader
        eyebrow="Our Menu"
        title="Combo Meals"
        subtitle="Our top-selling combos — a curry, rice, fresh bread and more in one complete meal. Choose your curry from the options below."
      />
      <MenuTabs />

      <section className="max-w-7xl mx-auto px-5 md:px-10 py-14 md:py-20">
        <StaggerGroup className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {combos.map((c) => (
            <StaggerItem key={c.name}>
              <ComboCard c={c} />
            </StaggerItem>
          ))}
        </StaggerGroup>

        {/* Choice of curries */}
        <Reveal className="mt-10">
          <ChooseYourCurry />
        </Reveal>
      </section>

      {/* CTA */}
      <section className="max-w-4xl mx-auto px-5 md:px-10 pb-20 md:pb-24 text-center">
        <Reveal>
          <h2 className="font-display font-bold text-3xl md:text-5xl text-white tracking-tight">Ready to order?</h2>
          <p className="mt-4 text-neutral-400 text-lg">Call us to place your order, or explore our full à la carte menu.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a href={`tel:${business.phoneRaw}`} data-testid="combo-call-btn"
              className="inline-flex items-center justify-center gap-2 bg-[#ffd100] text-[#0a0a0a] font-bold text-lg px-8 py-4 rounded-full hover:bg-[#e5bc00] transition-colors">
              <Phone size={20} /> {business.phone}
            </a>
            <button type="button" onClick={openOrder}
              className="inline-flex items-center justify-center border-2 border-white/20 text-white font-bold text-lg px-8 py-4 rounded-full hover:border-[#ffd100] hover:text-[#ffd100] transition-colors">
              Order Online
            </button>
            <Link to="/menu/a-la-carte"
              className="inline-flex items-center justify-center border-2 border-white/20 text-white font-bold text-lg px-8 py-4 rounded-full hover:border-[#ffd100] hover:text-[#ffd100] transition-colors">
              À La Carte Menu
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
